module.exports = __webpack_public_path__ + "img/badgeExample.bd5fbf1f.png";